import React from 'react';
import SingleSelectComponent from 'sulu-admin-bundle/components/SingleSelect';
import {isArrayLike, toJS} from 'mobx';

export let renderWithDisabled = function() {
    const {schemaOptions, disabled, value} = this.props;
    const values = toJS(schemaOptions.values);

    if (!values || !isArrayLike(values.value)) {
        throw new Error('The "values" schema option of the SingleSelect field-type must be an array!');
    }

    return (
        <SingleSelectComponent disabled={!!disabled} onChange={this.handleChange} value={value}>
            {/*$FlowFixMe: flow does not recognize that isArrayLike(value) means that value is an array*/}
            {values.value.map(({name: value, title, disabled}, index) => {
                if (typeof value !== 'string' && typeof value !== 'number' && value !== undefined) {
                    throw new Error(
                        'The children of "values" must only contain values of type string, number or undefined!'
                    );
                }

                // it is not possible to define a param without a name in a form xml. to allow for creating an
                // empty option, we use undefined as value if the name of a param is an empty string in the xml
                const normalizedValue = value === '' ? undefined : value;

                return (
                    <SingleSelectComponent.Option key={index} value={normalizedValue} disabled={disabled}>
                        {title || value}
                    </SingleSelectComponent.Option>
                );
            })}
        </SingleSelectComponent>
    );
}